import './QuizDetail.css';
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchQuiz } from '../../services/quizService';
import { getMyQuizResults } from '../../services/quizResultsService';
import { isLoggedIn } from '../../services/authService';

function QuizDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [quiz, setQuiz] = useState(null);
    const [myResult, setMyResult] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadQuiz = async () => {
            try {
                setLoading(true);
                setError(null);
                const data = await fetchQuiz(id);
                setQuiz(data);
                if (isLoggedIn()) {
                    const results = await getMyQuizResults();
                    setMyResult(results.find(r => r.quizId === id) ?? null);
                }
            } catch (err) {
                console.error('Error loading quiz:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        loadQuiz();
    }, [id]);

    if (loading) {
        return (
            <div className="quiz-detail-page">
                <div className="quiz-detail-container">
                    <p style={{ color: '#ddd', textAlign: 'center', padding: '3rem' }}>Načítání kvízu...</p>
                </div>
            </div>
        );
    }

    if (error || !quiz) {
        return (
            <div className="quiz-detail-page">
                <div className="quiz-detail-container">
                    <div className="not-found">
                        <h1>Kvíz nenalezen</h1>
                        <button onClick={() => navigate('/kvizy')} className="back-button">
                            Zpět na seznam kvízů
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const handleStartQuiz = () => {
        navigate(`/kvizy/${id}/start`);
    };

    return (
        <div className="quiz-detail-page">
            <div className="quiz-detail-container">
                <button onClick={() => navigate('/kvizy')} className="back-button">
                    ← Zpět na kvízy
                </button>

                {/* Title Section */}
                <header className="quiz-header">
                    <h1 className="quiz-detail-title">{quiz.title}</h1>
                </header>

                {/* Description & Tags Section */}
                {(quiz.shortDescription || quiz.description || (quiz.tags && quiz.tags.length > 0)) && (
                    <section className="detail-section">
                        <h2 className="section-title">Popis kvízu</h2>
                        {(quiz.description || quiz.shortDescription) && (
                            <p className="section-content">{quiz.description || quiz.shortDescription}</p>
                        )}
                        {quiz.tags && quiz.tags.length > 0 && (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '1rem' }}>
                                {quiz.tags.map((tag, index) => (
                                    <span key={index} style={{
                                        padding: '0.4rem 0.75rem',
                                        backgroundColor: 'rgba(233, 69, 96, 0.1)',
                                        border: '1px solid #e94560',
                                        borderRadius: '20px',
                                        color: '#eee',
                                        fontSize: '0.9rem'
                                    }}>
                                        {tag}
                                    </span>
                                ))}
                            </div>
                        )}
                    </section>
                )}

                {/* Start Button */}
                {quiz.questionIds && quiz.questionIds.length > 0 && (
                    <div className="start-button-container">
                        <button onClick={handleStartQuiz} className="start-quiz-button">
                            Spustit kvíz
                        </button>
                    </div>
                )}

                {/* Quiz Info */}
                {quiz.questionIds && quiz.questionIds.length > 0 && (
                    <div className="info-grid">
                        <section className="detail-section info-card">
                            <h2 className="section-title">Počet otázek</h2>
                            <div className="stat-number">{quiz.questionIds.length}</div>
                        </section>
                        {myResult && (
                            <section className="detail-section info-card">
                                <h2 className="section-title">Váš výsledek</h2>
                                <div className="stat-number" style={{ color: '#69c878' }}>
                                    {myResult.correctAnswers}/{myResult.totalQuestions}
                                </div>
                                <div className="stat-label">
                                    {Math.round((myResult.correctAnswers / myResult.totalQuestions) * 100)} %
                                </div>
                            </section>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default QuizDetail;
